(function () {
  'use strict';

  var END_WIDTH = 240;
  var END_HEIGHT = 48;
  var LOGO_TOP_GAP = 24;
  var HERO_HEIGHT_VW = 0.26;
  var MOBILE_BREAKPOINT = 992;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function isDrawerOpen() {
    return document.body.classList.contains('js-drawer-open-left');
  }

  function getEndSize() {
    if (!isMobile()) {
      return { width: END_WIDTH, height: END_HEIGHT };
    }
    return { width: 140, height: 36 };
  }

  function getLogoTopGap() {
    return isMobile() ? 12 : LOGO_TOP_GAP;
  }

  function easeInOutSine(t) {
    return -(Math.cos(Math.PI * t) - 1) / 2;
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function ScrollLogo() {
    this.header = document.querySelector('.site-header--scroll-logo');
    if (!this.header || !document.body.classList.contains('template-index')) {
      return;
    }

    this.keeper = this.header.querySelector('[data-logo-keeper]');
    this.navBar = this.header.querySelector('[data-header-scroll-nav]');
    if (!this.keeper || !this.navBar) {
      return;
    }

    this.ticking = false;
    this.navLocked = false;
    this.metrics = { helperTop: 0, helperHeight: 0, animStart: 0, animEnd: 0, range: 280 };

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onDrawerChange = this.onDrawerChange.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });
    window.addEventListener('load', this.onResize);

    this.drawerObserver = new MutationObserver(this.onDrawerChange);
    this.drawerObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    this.keeper.style.willChange = 'width, height, top, transform';
    this.measure();
    this.update();
  }

  ScrollLogo.prototype.onDrawerChange = function () {
    this.update();
  };

  ScrollLogo.prototype.measure = function () {
    var helper = document.querySelector('.template-index .logo-helper');
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    if (!helper) {
      this.metrics.range = Math.max(420, Math.min(window.innerHeight * 0.42, 560));
      return;
    }

    var rect = helper.getBoundingClientRect();
    var helperTop = rect.top + scrollY;
    var helperHeight = helper.offsetHeight;

    this.metrics.helperTop = helperTop;
    this.metrics.helperHeight = helperHeight;
    this.metrics.animStart = Math.max(0, helperTop - window.innerHeight * 0.35);
    this.metrics.animEnd = helperTop + helperHeight * 0.75;
    this.metrics.range = Math.max(this.metrics.animEnd - this.metrics.animStart, 280);
  };

  ScrollLogo.prototype.getScrollProgress = function (scrollY) {
    if (!this.metrics.helperHeight) {
      return Math.min(Math.max(scrollY / this.metrics.range, 0), 1);
    }
    return Math.min(Math.max((scrollY - this.metrics.animStart) / this.metrics.range, 0), 1);
  };

  ScrollLogo.prototype.getNavMetrics = function () {
    var rect = this.navBar.getBoundingClientRect();
    return {
      top: rect.top,
      bottom: rect.bottom,
      height: rect.height
    };
  };

  ScrollLogo.prototype.getNavLogoTop = function (nav, logoHeight) {
    return nav.top + (nav.height - logoHeight) / 2;
  };

  ScrollLogo.prototype.updateLockState = function (helper, nav) {
    if (!helper) {
      return;
    }

    var helperBottom = helper.getBoundingClientRect().bottom;

    if (!this.navLocked && helperBottom <= nav.bottom + 2) {
      this.navLocked = true;
    } else if (this.navLocked && helperBottom > nav.bottom + 48) {
      this.navLocked = false;
    }
  };

  ScrollLogo.prototype.update = function () {
    var endSize = getEndSize();
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var nav = this.getNavMetrics();
    var helper = document.querySelector('.template-index .logo-helper');
    var drawerOpen = isMobile() && isDrawerOpen();
    var rawProgress = this.getScrollProgress(scrollY);

    if (!drawerOpen) {
      this.updateLockState(helper, nav);
    }

    if (this.navLocked || drawerOpen) {
      rawProgress = 1;
    }

    var progress = easeInOutSine(rawProgress);
    var viewportW = window.innerWidth;
    var startHeight = viewportW * HERO_HEIGHT_VW;
    var startTop = nav.bottom + getLogoTopGap();
    var navLogoTop = this.getNavLogoTop(nav, endSize.height);

    var width = lerp(viewportW, endSize.width, progress);
    var height = lerp(startHeight, endSize.height, progress);
    var top = lerp(startTop, navLogoTop, progress);

    if (!this.navLocked && !drawerOpen && rawProgress > 0.65 && rawProgress < 1) {
      var blend = (rawProgress - 0.65) / 0.35;
      top = lerp(top, navLogoTop, blend);
    }

    var inNav = this.navLocked || rawProgress >= 1 || drawerOpen;

    this.header.classList.toggle('is-scrolled', scrollY > 4 || drawerOpen);
    this.header.classList.toggle('is-logo-nav', inNav);
    this.header.classList.toggle('is-drawer-open', drawerOpen);
    this.header.classList.toggle('is-logo-animating', !inNav && rawProgress > 0);
    this.keeper.classList.toggle('is-animating', !inNav && rawProgress > 0);

    if (inNav) {
      width = endSize.width;
      height = endSize.height;
      top = navLogoTop;
    }

    this.keeper.style.position = 'fixed';
    this.keeper.style.visibility = 'visible';
    this.keeper.style.opacity = '1';
    this.keeper.style.left = '50%';
    this.keeper.style.transform = 'translateX(-50%)';
    this.keeper.style.width = width + 'px';
    this.keeper.style.height = height + 'px';
    this.keeper.style.top = top + 'px';
  };

  ScrollLogo.prototype.onScroll = function () {
    if (!this.ticking) {
      this.ticking = true;
      var self = this;
      window.requestAnimationFrame(function () {
        self.ticking = false;
        self.update();
      });
    }
  };

  ScrollLogo.prototype.onResize = function () {
    this.measure();
    this.update();
  };

  function init() {
    new ScrollLogo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
